<template>
  <div class="create-user-container">
    <h5 class="create-user_title">
      {{ title }}
    </h5>
    <form @submit.prevent="createUser" class="create-user_form">
      <div class="create-user_input-group">
        <app-input-small
          class="create-user_input"
          :label="$t('CP.firstName')"
          v-model="$v.firstName.$model"
          :error="$v.firstName.$error"
        />
        <app-input-small
          class="create-user_input"
          :label="$t('CP.lastName')"
          v-model="$v.lastName.$model"
          :error="$v.lastName.$error"
        />
      </div>
      <div class="error">
        <div
          v-show="$v.firstName.$anyError"
          class="errorMessage"
        >
          {{ $t('validateText.firstNameRequired') }}
        </div>
        <div
          v-if="$v.lastName.$anyError"
          class="errorMessage"
        >
          {{ $t('validateText.lastNameRequired') }}
        </div>
        <div
          v-if="$v.$dirty && phoneError"
          class="errorMessage"
        >
          {{ $t('validateText.phoneIncorrect') }}
        </div>
      </div>
      <div class="create-user_button-group">
        <button-app
          class="create-user_button mr-4"
          color-scheme="blue"
          @clicked="cancelSubmit"
        >
          {{ $t('CP.cancel') }}
        </button-app>
        <button-app
          class="create-user_button"
          color-scheme="blue"
          @clicked="createUser"
        >
          {{ $t('CP.add') }}
        </button-app>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { CLEAR_SEARCH_CONTACT, CREATE_USER_CONTACT_REQUEST } from '@/store/user/types';
import { USER_PAYOUTS_REQUEST } from '@/store/events/types';
import AppInputSmall from '../../components/AppInputSmall/AppInputSmall';
import ButtonApp from '../../components/Button/ButtonApp';

export default {
  name: 'CreateUserForm',
  components: {
    ButtonApp,
    AppInputSmall,
  },
  props: {
    title: String,
    phone: {
      type: String,
      required,
    },
    closeMethod: { type: Function },
  },
  validations: {
    firstName: {
      required,
    },
    lastName: {
      required,
    },
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      errorMessage: '',
    };
  },
  computed: {
    phoneError() {
      return !this.phone.match(/^\+?\d\d?\d?\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{2})[- ]?(\d{2})$/);
    },
  },
  methods: {
    cancelSubmit() {
      this.$store.commit(CLEAR_SEARCH_CONTACT);
      this.$emit('cancelSearch');
    },
    async createUser() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      const fullName = `${this.firstName} ${this.lastName}`;
      const { phone } = this;
      if (this.phoneError || !fullName) {
        return;
      }

      await this.$store.dispatch(CREATE_USER_CONTACT_REQUEST,
        {
          contact: {
            name: fullName,
            phone,
          },
        });
      this.closeMethod();
      await this.$store.dispatch(USER_PAYOUTS_REQUEST);
    },
  },
};
</script>

<style scoped>
.create-user-container {
  color: var(--text-main-color);
  border: 1px solid var(--gray-lighten);
  padding: 32px;
  border-radius: 5px;
}

.create-user_form {
}

.create-user_input-group {
  display: flex;
  justify-content: space-between;
}

.create-user_input {
  flex: 0 1 45%;
}

.create-user_button-group {
  display: flex;
  flex-wrap: wrap;
}

.create-user_button {
  flex: 1 1 45%;
  height: 38px;
  margin: 20px 0 0 auto;
}

.error {
  margin-top: 20px;
  color: var(--error-red);
}

.errorMessage {
}
</style>
